// extracted by mini-css-extract-plugin
module.exports = {"scenario-section":"ScenarioSection_scenario-section__1iK_g","scenario-section--header":"ScenarioSection_scenario-section--header__15nVO"};